import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngButtonComponent } from './kng-button.component';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
	declarations: [KngButtonComponent],
	imports: [ CommonModule, MatIconModule, HttpClientModule ],
	exports: [KngButtonComponent],
	providers: []
})
export class KngButtonModule {}
